import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderService } from 'src/app/services/loader.service';

@Injectable()

export class LoaderInterceptor implements HttpInterceptor {
  totalRequests = 0;
  completedRequests = 0;
  constructor(private loaderService: LoaderService) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // if (!request.headers.get("skip")){
   // //debugger;
    this.loaderService.show();
    this.totalRequests++;

    return next.handle(request).pipe(
      finalize(() => {
        this.completedRequests++;

        if (this.completedRequests === this.totalRequests) {
          this.loaderService.hide()
          this.completedRequests = 0;
          this.totalRequests = 0;
        }
      }),
    );

  }
}
